/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  'use strict';

  var selector = '[data-montcalm-preorder-label]';
  var observedButtons = new WeakSet();

  function bindPreorder(container) {
    var button = container.querySelector('.product-form__add-button');
    if (!button || observedButtons.has(button)) return;

    var preorderLabel = container.getAttribute('data-montcalm-preorder-label');
    var addLabel = container.getAttribute('data-montcalm-add-label');
    if (!preorderLabel || !addLabel || preorderLabel === addLabel) return;

    function updateLabel() {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      if (button.textContent.trim() === addLabel.trim()) {
        button.textContent = preorderLabel;
      }
    }

    observedButtons.add(button);
    new MutationObserver(updateLabel).observe(button, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
    updateLabel();
  }

  function initialize(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    if (root.nodeType === 1 && root.matches(selector)) bindPreorder(root);
    root.querySelectorAll(selector).forEach(bindPreorder);
  }

  function start() {
    initialize(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(initialize);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
